<template>
  <div style="height: 100%">
    <section style="display: flex; height:100%">
      <div class="container manutencao_cont" style="margin: auto">
        <div class="row alinhamento">
          <div class="col-md-6 mt-5 mt-md-0">
            <h1>Site em<br>manutenção</h1>
            <p>Em breve estaremos de volta com nosso site melhorado.</p>
          </div>
          <div class="col-md-6 mt-5 mt-md-0">
            <img src="/static/images/manutencao.svg">
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: "Manutencao"
  }
</script>


// WEBPACK FOOTER //
// src/components/home/Manutencao.vue